import React from 'react';
import Seo from './common/Seo';
import Drawer from './common/Drawer';
import PageTitle from './common/PageTitle';
import { useI18n } from './i18n/I18nContext';
import Chatbot from './contact/Chatbot';

export default function Contact({ route }) {
  const { t, locale } = useI18n();
  return <>
    <Seo title={t('pages.contact.title')} description={t('pages.contact.description')} />
    <PageTitle id="contact" title={t('pages.contact.heading')} text={t('chat.intro')} />
    <Chatbot key={locale} />
    <Drawer route={route} />
  </>;
}
